import Styles from "./index.module.css";
import cx from "classnames";

const Tags = ({ text, type }) => {
  return <span className={cx(Styles.tag, Styles[type])}>{text}</span>;
};

export default Tags;
